import React from "react";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { CtaLink } from "./CtaLink";
import { Reveal } from "./Reveal";
import { CONTACT } from "../../data/site";
type Props = {
  title?: React.ReactNode;
  lead?: string;
  source: string;
};
export function CtaBand({
  title = <>Ready for a <span className="text-accent" data-id="element-429" data-mp="102dhgr0boqd9">better</span> website?</>,
  lead = "Tell us about your business. We'll confirm scope and price in writing before any work begins.",
  source
}: Props) {
  return <section className="shell section" data-id="element-430" data-mp="r0nnpeiyxfcb">
      <Reveal className="relative overflow-hidden rounded-[clamp(1.25rem,2vw,2.5rem)] border border-line bg-ink-2 px-[clamp(1.5rem,5vw,7rem)] py-[clamp(3rem,6vw,8rem)]" data-id="element-431" data-mp="qzm3ajg2bghx">
        <div className="blue-glow-center pointer-events-none absolute inset-0" aria-hidden data-id="element-432" data-mp="h3so0sayl8wg" />
        <div className="grid-lines pointer-events-none absolute inset-0 opacity-60" aria-hidden data-id="element-433" data-mp="2ggdcbnkb9ptn" />
        <div className="relative grid gap-10 lg:grid-cols-[1.5fr_1fr] lg:items-end" data-id="element-434" data-mp="2bgqypd0km7kb">
          <div data-id="element-435" data-mp="2p6bsirl2mzs4">
            <h2 className="t-h2 max-w-[16ch]" data-id="element-436" data-mp="2p5tubpeumbhk">{title}</h2>
            <p className="t-lead mt-6 max-w-[48ch] text-fg-2" data-id="element-437" data-mp="2p8g31sdh6x1d">{lead}</p>
          </div>
          <div className="flex flex-wrap gap-3 lg:justify-end" data-id="element-438" data-mp="2t5kkbqwjwnl1">
            <CtaLink to="/contact" track={`cta_band_build_${source}`} size="lg" data-id="element-439" data-mp="2f97ddbpn84kt">
              Build My Website <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-440" data-mp="2k7s2aezg31ty" />
            </CtaLink>
            <CtaLink to={CONTACT.phones[0].href} variant="ghost" track={`cta_band_call_${source}`} size="lg" data-id="element-441" data-mp="37yxiiv9arw4s">
              <PhoneIcon className="h-4 w-4" data-id="element-442" data-mp="2y6rqjlj1pepl" /> {CONTACT.phones[0].label}
            </CtaLink>
          </div>
        </div>
      </Reveal>
    </section>;
}